import {date} from '@eitje/utils'

export const formatDate = value => {
	// Prevent moment from returning today when `date(undefined)` is invoked!
	if (!value) return null
	return date(value).formatDate({year: true})
}

export const DateCell = ({getValue}) => {
	return formatDate(getValue())
}

export const formatDateTime = value => {
	return date(value).formatDate({year: true, time: true})
}

export const DateTimeCell = ({getValue}) => {
	return formatDateTime(getValue())
}
